// extracted by mini-css-extract-plugin
export default {"container":"EmailConfirmationSend_container__J2lSu","card":"EmailConfirmationSend_card__+4iRg","title":"EmailConfirmationSend_title__vydA8"};